// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_container {
  text-align: justify;
  max-width: 600px;
}

div [mat-dialog-title] {
  display: flex;
  justify-content: center;
  align-items: center;
}

mat-dialog-actions {
  justify-content: center;
  margin: 12px 0 0 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/dialogs/confirmation-dialog/confirmation-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,uBAAA;EACA,kBAAA;AACJ","sourcesContent":[".dialog_container {\r\n    text-align: justify;\r\n    max-width: 600px;\r\n}\r\n\r\ndiv [mat-dialog-title] {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center ;\r\n}\r\n\r\nmat-dialog-actions {\r\n    justify-content: center;\r\n    margin: 12px 0 0 0 ;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
